import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";
import InReviewJobsList from "./components/in-review-jobs";
import InProgressJobsList from "./components/in-progress-jobs";
import UpcomingBillablesList from "./components/upcoming-billables";
import ExtendedBillablesList from "./components/extended-billables";
import JCTimesheetSummaryList from "./components/jc-timesheet-summary";
import PCTimesheetSummaryList from "./components/pc-timesheet-summary";
import TeamAllocationSummaryList from "./components/team-allocation-summary";
import TeamBillability from "./components/team-billability";

import PendingBillablesList from "./components/pending-billables";
import JobsOverviewFilters from "./filter";

const JCOverviewReport = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const employeeIdFromUrl = searchParams.get("employeeId");

  const [filters, setFilters] = useState(() => {
    const savedId = sessionStorage.getItem("jobs_overview_filter_employeeId");
    return {
      employeeId: employeeIdFromUrl || savedId || undefined, // Use undefined as default
    };
  });

  // Sync URL params with state
  useEffect(() => {
    if (employeeIdFromUrl) {
      setFilters((prev) => ({
        ...prev,
        employeeId: employeeIdFromUrl,
      }));
    } else {
      setFilters((prev) => ({
        ...prev,
        employeeId: undefined,
      }));
    }
  }, [employeeIdFromUrl]);

  const handleSetFilters = (newFilters) => {
    const value =
      typeof newFilters === "function" ? newFilters(filters) : newFilters;

    // Update URL params
    setSearchParams((prev) => {
      if (value.employeeId) {
        prev.set("employeeId", value.employeeId);
        sessionStorage.setItem(
          "jobs_overview_filter_employeeId",
          value.employeeId,
        );
      } else {
        prev.delete("employeeId");
        sessionStorage.removeItem("jobs_overview_filter_employeeId");
      }
      return prev;
    });

    // Update local state
    setFilters((prev) => ({
      ...prev,
      ...value,
      employeeId: value.employeeId || undefined, // Ensure undefined for cleared state
    }));
  };

  const { employeeId } = filters;
  const { id } = useSelector(selectUser);

  return (
    <div className="flex-1 overflow-auto">
      <JobsOverviewFilters filters={filters} setFilters={handleSetFilters} />
      <div>
        <InReviewJobsList coordinatorId={employeeId || id} />
        <InProgressJobsList coordinatorId={employeeId || id} />
        <UpcomingBillablesList coordinatorId={employeeId || id} />
        <ExtendedBillablesList coordinatorId={employeeId || id} />
        <PendingBillablesList coordinatorId={employeeId || id} />
        <JCTimesheetSummaryList coordinatorId={employeeId || id} />
        <PCTimesheetSummaryList coordinatorId={employeeId || id} />
        <TeamAllocationSummaryList coordinatorId={employeeId || id} />
        <TeamBillability employeeId={employeeId} />
        {/* <OverrunJobsReports coordinatorId={employeeId || id} />
        <UnderrunJobsReports coordinatorId={employeeId || id} /> */}
      </div>
    </div>
  );
};

export default JCOverviewReport;
